import { render, staticRenderFns } from "./ProgramsSingleDetails.vue?vue&type=template&id=58885086&"
import script from "./ProgramsSingleDetails.vue?vue&type=script&lang=js&"
export * from "./ProgramsSingleDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports